import {
	AdminRoutes,
	AnalyzerRoutes,
	AutoEuropeToolRoutes,
	BatchRoutes,
	HomeRoute,
	NotFoundRoute,
	OneWayRoutes,
	RealTimeRoutes,
	reportRoutes,
	RootRoute,
	SessionRoutes,
	UserSettingsRoutes,
	BusinessLogisticsRoutes,
} from 'Pages'


const routes = userData => ([
	RootRoute,
	HomeRoute,
	AnalyzerRoutes(userData),
	reportRoutes(userData),
	...OneWayRoutes(userData),
	RealTimeRoutes,
	...BusinessLogisticsRoutes(userData),
	...AutoEuropeToolRoutes(userData),
	BatchRoutes(userData),
	UserSettingsRoutes,
	AdminRoutes(userData),
	...SessionRoutes,
	NotFoundRoute,
])

export default routes